var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDebitBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .debitBox{fill:none;stroke:#f44336;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "Group_27265",
    "data-name": "Group 27265",
    transform: "translate(-262 -259)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18245",
    "data-name": "Group 18245",
    transform: "translate(-256.758 -2.26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8567",
    "data-name": "Path 8567",
    d: "M488.193 497.813a60.276 60.276 0 0 1 13.261 0 5.639 5.639 0 0 1 4.978 4.917 57.758 57.758 0 0 1 0 13.434 5.638 5.638 0 0 1-4.978 4.917 60.3 60.3 0 0 1-13.261 0 5.638 5.638 0 0 1-4.978-4.917 57.764 57.764 0 0 1 0-13.434 5.639 5.639 0 0 1 4.978-4.917zm13.025 2.106a58.255 58.255 0 0 0-12.788 0 3.519 3.519 0 0 0-3.1 3.059 55.709 55.709 0 0 0 0 12.939 3.519 3.519 0 0 0 3.1 3.059 58.247 58.247 0 0 0 12.788 0 3.517 3.517 0 0 0 3.1-3.059 55.548 55.548 0 0 0 0-12.939 3.517 3.517 0 0 0-3.101-3.059z",
    transform: "translate(35.935 -236.187)",
    style: {
      fill: "#8c8d99",
      fillRule: "evenodd"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_18325",
    "data-name": "Group 18325",
    transform: "translate(.693 -1.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    className: "debitBox",
    d: "M379.181 270.48 373 264.3a1.007 1.007 0 0 0-1.414 0l-.839.84a1.007 1.007 0 0 1-1.414 0l-1.9-1.9",
    transform: "translate(-100.126 5.193)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    className: "debitBox",
    d: "M376.181 266.24h3v-3",
    transform: "translate(-100.126 9.387)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitBox);
export default __webpack_public_path__ + "static/media/debit-box.8e2e309cb77896f97da002a5e5ab6f89.svg";
export { ForwardRef as ReactComponent };